
let DateUtilFactory = function ($translate) {
    var date = null;

    const getUTCDate = function (date) {
        const ISOString = moment(date).toISOString();
        const DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

        return ISOString.substr(0, DATE_STRING_LENGTH);
    }

    const convertToDate = function (date) {
        const ISOString = moment(date).toISOString();
        const DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

        const dateString = ISOString.substr(0, DATE_STRING_LENGTH);
        return moment(dateString).toDate();
    }
    const convertToUTCDate = function (date) {
        const ISOString = moment.utc(date).toISOString();
        const DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

        const dateString = ISOString.substr(0, DATE_STRING_LENGTH);
        return moment.utc(dateString).toDate();
    }

    const convertTime = function (time, isUTC = false) { // UTC time
        if (!time) {
            return time;
        }

        time = time.split(':');

        let d = new Date();

        d.setUTCHours(+time[0]);
        d.setUTCMinutes(time[1]);
        d.setUTCSeconds(0);
        d.setUTCMilliseconds(0);

        return isUTC ? moment.utc(d).format('hh:mm A') : moment(d).format('hh:mm A');
    }

    const convetToBrowserTimezone = function (date, isDisplaySec=false) {
        var browserTimezone = moment.tz.guess(); // get the browsers current time zone.
        var abbreviation = moment().tz(browserTimezone).format('z'); // abbreviation of browserTimezone
        var convertDate = isDisplaySec ?  moment.tz(date, browserTimezone).format('YYYY-MM-DD | hh:mm:ss A') : moment.tz(date, browserTimezone).format('YYYY-MM-DD | hh:mm A');  // convert date to specific timezone
        var dateString = convertDate.concat(' ', abbreviation)
        return dateString;
    }

    // calculate hours, minutes, seconds between two date
    const calculateDuration = function (startDate, endDate) {
        let ms = moment(endDate).diff(startDate);
        let duration = moment.duration(ms);
        return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
    }

    let convertDateTime = (date, timezone, dateFormat) => {
        if (!date) return;
        return moment.tz(date, timezone).format(dateFormat);
    }

    let getTime = (time) => {
        if (!time) {
            return time;
        }
    
        time = time.split(':');
    
        let d = new Date();
    
        d.setHours(+time[0]);
        d.setMinutes(time[1]);
        d.setSeconds(0);
        d.setMilliseconds(0);
    
        return d;
    }

    const convertToTimeFormat = function (durationString) {
        if (!durationString) return;
        const hoursMatch = durationString.match(/(\d+)\s*hour/);
        const minutesMatch = durationString.match(/(\d+)\s*minute/);
        const secondsMatch = durationString.match(/(\d+)\s*second/);

        const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
        const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
        const seconds = secondsMatch ? parseInt(secondsMatch[1], 10) : 0;

        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    const getTZFormattedDate = (date, timezone, dateFormat = 'YYYY-MM-DD') => {
        if (!date) return;

        const targetTz = timezone || moment.tz.guess();
        const utcMoment = moment.utc(date);
        const isMidnight = utcMoment.hours() === 0 && utcMoment.minutes() === 0 && utcMoment.seconds() === 0;

        let formattedDate;

        if (isMidnight) {
            formattedDate = utcMoment.format(dateFormat);
        } else {
            formattedDate = utcMoment.tz(targetTz).format(dateFormat);
        }

        return `${formattedDate}T00:00:00Z`;
    };

    return {
        getUTCDate,
        convertToDate,
        convertToUTCDate,
        convertTime,
        convetToBrowserTimezone,
        calculateDuration,
        convertDateTime,
        getTime,
        getTZFormattedDate,
        convertToTimeFormat
    }
}

DateUtilFactory.$inject = ['$translate'];

export default DateUtilFactory;



// WEBPACK FOOTER //
// ./client/app/common/date-util/date-util.factory.js